// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YmE9","footer":"styles_footer__MjxXM","passCodeTooltip":"styles_passCodeTooltip__3vR3O"};